import {register} from '@shopify/theme-sections'
import '../../styles/sections/tabs-content.scss'

export default register(`content-with-tabs`, {
    onload() {
    },
    onUnload() {
    }
})
